/**
 * Shared motion presets for PowerBuilt.
 * Use these instead of hand-rolling variants to keep the rhythm consistent
 * across the whole app (250ms quick, 380ms standard, 600ms hero).
 */
export const EASE = [0.22, 0.61, 0.36, 1]; // Apple-style ease-out
export const EASE_SOFT = [0.4, 0, 0.2, 1];

// Page transition (drop into <motion.div> wrapping a route)
export const pageFade = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: { duration: 0.28, ease: EASE_SOFT },
};

// Card / tile entrance (staggered via parent container)
export const cardRise = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.38, ease: EASE } },
};

// Container that staggers its children
export const stagger = (delay = 0.04) => ({
  hidden: {},
  show: { transition: { staggerChildren: delay, delayChildren: 0.04 } },
});

// Button micro-interaction (hover + press)
export const tap = { whileHover: { y: -1 }, whileTap: { scale: 0.97 } };
